export default __webpack_public_path__ + "static/media/tag-blue.9c72d0de.svg";